import { baseUrl } from 'api/API_App';

/**
 * Đổi path KIOS (tương đối, `/storage/...`, hoặc URL đầy đủ) thành URL proxy của Gate.
 * Storage KIOS không gửi Access-Control-Allow-Origin và chặn iframe (X-Frame-Options: SAMEORIGIN),
 * nên react-pdf không tải được file nếu trỏ thẳng.
 */
export const pdfFileParser = (path: string): { to: string; fileName: string } => {
  const rawName = path.split('/').pop()?.split('?')[0] || '';
  let fileName = rawName;
  try {
    fileName = decodeURIComponent(rawName);
  } catch {
    fileName = rawName;
  }
  let relative = path.trim();

  if (/^https?:\/\//i.test(relative)) {
    try {
      relative = new URL(relative).pathname;
    } catch {
      /* giữ nguyên, bước dưới vẫn cắt prefix storage */
    }
  }

  relative = relative
    .replace(/^\/+/, '')
    .replace(/^storage\//i, '')
    .replace(/\s/g, ' ');

  const apiBase = (baseUrl || '').replace(/\/+$/, '');
  const to = `${apiBase}/external/kios/storage-file?path=${encodeURIComponent(relative)}`;

  return { to, fileName };
};
